import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})

export class ContribuicaoService {

    constructor(private http: HttpClient, private util: UtilService) {

    }

    public alterarContribuicao(form){
        return this.http
                   .put(`${environment.apiURL}/Logado/Contribuicao/AlterarComtribuicao`,form)
    }

    public buscaValorContribuicao(){
        return this.http
                   .get(`${environment.apiURL}/Logado/Contribuicao/BuscaValorContribuicao`)
    }


}
